import { render, staticRenderFns } from "./trafficRecharge.vue?vue&type=template&id=40f3b8b7&scoped=true"
import script from "./trafficRecharge.vue?vue&type=script&lang=js"
export * from "./trafficRecharge.vue?vue&type=script&lang=js"
import style0 from "./trafficRecharge.vue?vue&type=style&index=0&id=40f3b8b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3b8b7",
  null
  
)

export default component.exports